import(/* webpackMode: "eager" */ "/srv/apps/admin/app/login/page.tsx");
